import { render, staticRenderFns } from "./UploadModal.vue?vue&type=template&id=1926def6&scoped=true&"
import script from "./UploadModal.vue?vue&type=script&lang=js&"
export * from "./UploadModal.vue?vue&type=script&lang=js&"
import style0 from "./UploadModal.vue?vue&type=style&index=0&id=1926def6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1926def6",
  null
  
)

export default component.exports